export default __webpack_public_path__ + "static/media/fake-objects@3x.ba4af016.png";